export default "__VITE_ASSET__COdkNCG1__"